'use strict';

import baseApi from './base-api';

export default class CalendarApi extends baseApi {
  getNowShowingProducts(productSid = '') {
    let params = {'product_sid': productSid},
        resurt = this.getApiRequest('/products/calendar/now_showing', params);
        return resurt;
  }
  getProductCalendarProducts(startDay, endDay, productSid = '') {
    let params = {'product_sid': productSid},
        resurt = this.getApiRequest(`/products/calendar/index/${startDay}/${endDay}`, params);
        return resurt;
  }
}